import { useSavedInRef } from '@coop/hooks';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch } from '../../../hooks/useThunkDispatch';
import { currentPageActions } from '../../../store/slices/currentPage/currentPageSlice';
import { getFilteredQueryStringForVirtualPageView } from './PageProperties.utils';

interface GaVirtualPageParams {
    pageTitle: string;
    canonicalUrl?: string;
    pageTypeName?: string;
    /**
     * Used to specify what key must have been changed in URL's query string to trigger Virtual Page View
     * By defualt, pagination's "page" is always a trigger, rest of the triggers are set on page-to-page basis
     */
    queryStringTriggers?: string[];
}

export const useGaVirtualPageView = (options?: GaVirtualPageParams) => {
    const { search } = useLocation();
    const dispatch = useAppDispatch();

    const canonicalUrl =
        options &&
        options.canonicalUrl &&
        new URL(options.canonicalUrl, window.location.origin).toString();

    // used only in dependency array to trigger effect
    const triggerString = getFilteredQueryStringForVirtualPageView(
        search,
        (options && options.queryStringTriggers) || [],
    );

    const enable = !!options;

    const sendEvent = useSavedInRef(() => {
        if (canonicalUrl) {
            dispatch(
                currentPageActions.setPageGaData({
                    canonicalUrl,
                    gaPageTypeName: options && options.pageTypeName,
                    title: options && options.pageTitle,
                    queryString: window.location.search,
                }),
            );
        }
    });

    useEffect(() => {
        if (enable && canonicalUrl) {
            sendEvent.current();
        }
    }, [dispatch, enable, canonicalUrl, triggerString, sendEvent]);

    return {
        sendEvent,
    };
};
